/** Full document navigation so a just-set cookie is on the next request. */
export function hardNavigate(path) {
  window.location.replace(path);
}
